import { DownloadManagerAction, DownloadManagerActionKeys } from './actions';
import Utils from '../../utils';

export interface DownloadManagerState {
	isDownloadingAll: boolean;
	isDeletingAll: boolean;
	downloadAllStatus: DownloadAllStatus;
	items: { [k: number]: DownloadManagerItemState };
}

const getInitialState = (): DownloadManagerState => ({
	isDownloadingAll: false,
	isDeletingAll: false,
	downloadAllStatus: DownloadAllStatus.NotStarted,
	items: {}
});

export enum DownloadAllStatus {
	NotStarted = 'notStarted',
	Started = 'started',
	Finished = 'finished'
}

export interface Progress {
	totalSize?: number;
	loaded?: number;
}

export enum DownloadMode {
	Temp = 'temporary',			// Needed for Api.DriveItemType.File on Android
	Requested = 'requested',	// When the user explicitly download the item
	Dependency = 'dependency',	// Dependency of a Requested, Required or Temp
	Required = 'required'		// For items in Menu that needs to be download on initialization for offline support
}

export enum DownloadStatus {
	NOT_DOWNLOADED = 'NOT_DOWNLOADED',
	INIT = 'INIT',
	GETTING_DEPENDENCIES = 'GETTING_DEPENDENCIES',
	NATIVE_DOWNLOADING = 'NATIVE_DOWNLOADING',
	NATIVE_DOWNLOADED = 'NATIVE_DOWNLOADED',
	ERROR = 'ERROR',
	OUTDATED = 'OUTDATED'
}

export interface DownloadManagerItemState {
	mode: DownloadMode;
	status: DownloadStatus;
	progress?: Progress;
	version: number;
	requestId?: number;
	dependencies: number[];
	dependents: number[];
}

const downloadManagerItemInitialState: DownloadManagerItemState = {
	mode: DownloadMode.Requested,
	status: DownloadStatus.NOT_DOWNLOADED,
	version: -1,
	dependencies: [],
	dependents: []
};

export function downloadManager(state: DownloadManagerState = getInitialState(), action: DownloadManagerAction): DownloadManagerState {

	let newState = Utils.deepCopy(state);
	let item: DownloadManagerItemState;

	switch (action.type) {
		case DownloadManagerActionKeys.SET_DOWNLOAD_ALL_STATUS:
			newState.downloadAllStatus = action.status;
			return newState;

		case DownloadManagerActionKeys.SET_IS_DOWNLOADING_ALL:
			newState.isDownloadingAll = action.isDownloadingAll;
			return newState;

		case DownloadManagerActionKeys.SET_DELETE_ALL_STATUS:
			newState.isDeletingAll = action.isDeletingAll;
			return newState;

		case DownloadManagerActionKeys.INIT_DOWNLOADS:
			action.downloads.forEach(item => newState.items[item.id] = {
				mode: item.mode,
				status: item.status,
				version: item.version,
				dependencies: item.dependencies,
				dependents: item.dependents
			});
			return newState;

		case DownloadManagerActionKeys.ADD_ITEM:
			let newItem: DownloadManagerItemState = getItemFromMap(newState.items, action.id);
			newItem.mode = action.mode;
			newItem.dependencies = action.dependencies;
			newItem.dependents = action.dependents;
			newItem.version = action.version;
			newItem.status = DownloadStatus.INIT;
			newState.items[action.id] = newItem;
			return newState;

		case DownloadManagerActionKeys.UPDATE_STATUS:
			item = getItemFromMap(newState.items, action.id);
			item.status = action.status;
			newState.items[action.id] = item;
			return newState;

		case DownloadManagerActionKeys.SET_REQUEST_ID:
			item = getItemFromMap(newState.items, action.id);
			item.requestId = action.requestId;
			item.status = DownloadStatus.NATIVE_DOWNLOADING;
			newState.items[action.id] = item;
			return newState;

		case DownloadManagerActionKeys.RECORD_DOWNLOAD_PROGRESS:
			item = getItemFromMap(newState.items, action.id);
			item.progress = action.progress;
			newState.items[action.id] = item;
			return newState;

		case DownloadManagerActionKeys.UPDATE_DOWNLOAD:
			item = getItemFromMap(newState.items, action.id);
			item.mode = action.mode;
			item.dependencies = action.dependencies;
			item.dependents = action.dependents;
			item.version = action.version;
			newState.items[action.id] = item;
			return newState;

		case DownloadManagerActionKeys.REMOVE_DOWNLOAD:
			delete newState.items[action.id];
			return newState;
		default:
			return state;
	}
}

function getItemFromMap(items: { [k: number]: DownloadManagerItemState }, itemId: number): DownloadManagerItemState {
	return items[itemId] ? items[itemId] : Utils.deepCopy(downloadManagerItemInitialState);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadManager/reducer.ts